import ITexts from "./ITexts";

const en: ITexts = {
  donation_project_list_header: "Donate",
  donation_project_list_item_go_to_project: "View organization",
  donation_1_donate_now_1: "Donate from ",
  donation_1_donate_now_2: " now",
  donation_abort_button: "Cancel",
  donation_info: "Note: To complete your donation, you will be redirected to the organization’s secure donation page.",
  donation_info_2: `<b>Would you like to receive a donation receipt?  </b><br/> <br/>

If you need a receipt, we are happy to provide one for you.

<i>Note: If you select “Yes,” the organization will send you a donation receipt by 	email. 
	It is possible to request it later, but the process may take longer. </i>`,
  donation_info_2_1: `<b>Information for your donation receipt </b> <br/><br/>

In order for the organization to issue your donation receipt correctly, we need the following information from you: `,
  donation_info_3: `<b>Thank you for your donation! </b><br/><br/>

With your support, the organization can continue its important work. <br/><br/>

<b>Would you like to do even more? </b><br/><br/>
On bettervest, you can: <br><br>
<ul>
  <li>Support additional verified charity organizations, or </li>
  <li>Make a measurable difference through Impact Investments, achieving both social impact and financial returns. </li>
</ul>
<br><br>
<i>Together with the bettervest crowd, you can create real impact – for a better future! </i>`,
  donation_alert: `<b>Thank you for your decision to support this organization. </b><br/> <br/>
<i>Note: For the final donation transaction, you will be redirected to the organization’s secure donation page. There, you will need to re-enter the donation amount. </i>`,
  donation_now_disabled: "Register and donate",
  donation_continue: "Continue",
  donation_progress_bar_by: "by",
  donation_progress_bar_donator: "Investor",
  donation_progress_bar_donators: "Investors",
  donation_side_bar_requiredBudget: "Donation goal",
  donation_side_bar_region: "Region",
  donation_side_bar_mainFocus: "Main focus",
  donation_side_bar_matchFunding: "Matchfunding",
  donation_close_button: "Close",
  donation_1_hint_project_not_donate: "Donations to this project are currently not possible.",
  donation_1_hint_only_logged_in: "Only registered users can make donations",
  donation_1_hint_before_start: "The donation period for this project has not started yet",
  donation_1_hint_after_end: "The donation period for this project has ended",
  donation_1_donate_btn: "Confirm amount",
  donation_info_tax_btn_yes: "Yes, I would like a donation receipt",
  donation_info_tax_btn_no: "Donate now without a receipt",
  donation_3_preview_intro: "Your current personal details are required to issue the donation receipt",

  donation_3_preview_call_to_action: "Is the data still current and correct?",
  donation_3_preview_change_profile_button: "No, correct data",
  donation_3_preview_continue_button: "Yes, current & correct",
  donation_3_edit_title: "Change personal information",
  donation_3_edit_alert_message: "Please note the following",
  donation_3_edit_alert_description: "Changing your last name or address will result in you being identified again.",
  donation_3_edit_back_without_save_button: "Back",
  donation_3_edit_save_and_back_button: "Save and Donate",
  donation_3_firstName: "First Name",
  donation_3_lastName: "Last name",
  donation_3_country: "Country",
  donation_3_city: "City",
  donation_3_postalCode: "Postal Code",
  donation_3_streetName: "Street",
  donation_3_streetNumber: "Street Number",
  donation_3_addition: "Addition",
  donation_3_address: "Address",
  donation_3_companyDataTitle: "Company Data:",
  donation_3_companyName: "company name",
  donation_3_legalForm: "Legal Form",
  donation_3_registerId: "Register number",
  donation_3_court: "Registrar",
  donation_3_legalAddress: "Business Address",

  donation_3_save_disabled_loading: "Wird gespeichert...",
  donation_3_save_disabled_no_changes: "Keine Änderungen vorhanden",
  donation_3_save_disabled_natural_invalid: "Bitte füllen Sie alle Pflichtfelder der natürlichen Person aus",
  donation_3_save_disabled_legal_invalid: "Bitte füllen Sie alle Pflichtfelder des Unternehmens aus"
};

export default en;
